<template>
  <div class="smsc-container">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start"></div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            class="mt-3"
            @click="Add"
          >Add Account</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div slot="no-body" class="p-3">
        <smsc-col>
          <smsc-col-item>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="input"
              name="first name"
              class="w-100"
              :class="{'is-danger': errors.has('first name')}"
              type="text"
              label="First Name"
              placeholder="Enter first name"
              v-model="payload.first_name"
            />
            <span class="text-danger text-xs">{{ errors.first('first name') }}</span>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="input"
              name="last name"
              class="w-100"
              :class="{'is-danger': errors.has('last name')}"
              type="text"
              label="Last Name"
              placeholder="Enter last name"
              v-model="payload.last_name"
            />
            <span class="text-danger text-xs">{{ errors.first('last name') }}</span>
          </smsc-col-item>
          <smsc-col-item>
            <label class="vs-input--label">Status</label>
            <v-select
              v-validate="'required'"
              data-vv-validate-on="input"
              name="status"
              :class="{'is-danger': errors.has('status')}"
              label="name"
              :options="status"
              :searchable="false"
              v-model="selected.status"
              placeholder="Select Status"
              @input="payload.is_active = $event && $event.value"
            />
            <span class="text-danger text-xs">{{ errors.first('status') }}</span>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input
              v-validate="'required', 'max:16'"
              data-vv-validate-on="input"
              name="password"
              class="w-100"
              :class="{'is-danger': errors.has('password')}"
              type="password"
              label="Password"
              placeholder="Enter password"
              v-model="payload.passwd"
            />
            <span class="text-danger text-xs">{{ errors.first('password') }}</span>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="input"
              name="user name"
              class="w-100"
              :class="{'is-danger': errors.has('user name')}"
              type="text"
              label="User Name"
              placeholder="Enter user name"
              v-model="payload.user_name"
            />
            <span class="text-danger text-xs">{{ errors.first('user name') }}</span>
          </smsc-col-item>
          <smsc-col-item>
            <label class="vs-input--label">Product</label>
            <v-select
              name="product"
              label="name"
              class="productOption111"
              :options="payload.products"
              v-model="selected.products"
              placeholder="Select Product"
              @input="eventProduct"
            />
          </smsc-col-item>
          <smsc-col-item>
            <label for="Allowed_API_IP" class="ip-label">Allowed API IP</label>
            <vue-ip-input
              id="Allowed_API_IP"
              :on-change="onIpChange"
              :ip="ip"
              v-validate="'ip'"
              name="API IP"
              class="w-100 vue-input-ip"
              :class="{'is-danger': errors.has('API IP')}"
              type="text"
            />
            <span class="text-danger text-xs">{{ errors.first('API IP') }}</span>
          </smsc-col-item>
          <smsc-col-item>
            <label for="SMPP_IP" class="ip-label">Allowed SMPP IP</label>
            <vue-ip-input
              id="SMPP_IP"
              :on-blur="onIpBlur"
              :ip="ip_smpp"
              v-validate="'ip'"
              name="SMPP IP"
              class="w-100 vue-input-ip"
              :class="{'is-danger': errors.has('SMPP IP')}"
              type="text"
            />
            <span class="text-danger text-xs">{{ errors.first('SMPP IP') }}</span>
          </smsc-col-item>
        </smsc-col>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Packages
import vSelect from 'vue-select'
import VueIpInput from 'vue-ip-input';
export default {
  components: {
    vSelect,
    'vue-ip-input': VueIpInput
  },
  data() {
    return {
      // Dropdowns
      status: [
        { name: 'Active', value: true },
        { name: 'Inactive', value: false }
      ],
      ip: '',
      ip_smpp: '',
      // Selected
      selected: {
        status: { name: 'Active', value: true },
      },

      // Request body
      payload: {
        first_name: null,
        last_name: null,
        user_name: null,
        passwd: null,
        is_active: true,
        allowed_api_ip_list: '',
        allowed_ip_list: '',
        company_uuid: this.$route.params.id,
        products: []
      }
    }
  },
  mounted() {
    this.GetProductList()
  },
  methods: {
    eventProduct(event) {
      //payload.products = $event && $event.value
      console.log(event);
    },
    onIpChange(ip) {
      this.payload.allowed_api_ip_list = ip
      this.payload.allowed_ip_list = ip
    },
    onIpBlur(ip) {
      this.payload.allowed_ip_list = ip
    },
    GetProductList() {
      this.$store.dispatch('product/GetList')
        .then((res) => {
         this.payload.products = res.items.map(this.TransformCompany)
        }).catch(() => {}).finally(() => {})
    },
    async Add() {
      const valid = await this.$validator.validate()

      if (!valid) {
        return
      }
      this.$vs.loading()

      let obj = {...this.payload};
      obj.products = [this.selected.products.product_uuid]
      this.$store.dispatch('user/Add', obj)
      .then(res => {
        this.$router.push({ name: 'admin-companies-company-accounts', params: { id: this.$route.params.id } })
        this.ShowSuccessMessage({ title: 'Success', text: 'Account has been added' })
      })
      .catch(err => {
        let resErrorK = Object.keys(err[0])
        let resErrorV = Object.values(err[0])
        if(typeof resErrorV === 'object'){
          resErrorV = Object.values(err[0][resErrorK])
        }
        this.ShowErrorMessage({ title: 'Error', text: resErrorK[0] + ' ' +resErrorV[0] })
      })
      .finally(() => this.$vs.loading.close())
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },
    // Transform functions
    TransformCompany(item) {
      return {
        product_uuid: item.product_uuid,
        name: item.product_name,
      }
    }
  }
}
</script>
<style>
.productOption111>.vs__dropdown-toggle>.vs__actions>.vs__clear{
  display: none !important;
}
</style>

<style scoped lang="scss">
.vue-input-ip {
  display: inline-block!important;
  height: 41px!important;
  line-height: normal!important;
  border: 1px solid #ccc!important;
  border-radius: 4px!important;
  box-sizing: border-box!important;
  background-color: #fff!important;
  &:active {
    border: 1px solid #7366ff!important;
  }
  &:focus {
    border: 1px solid #7366ff!important;
  }
}
.ip-label {
  font-size: .85rem!important;
  color: rgba(0,0,0,.7) !important;
}
</style>
